module.exports = __webpack_public_path__ + "static/AvenirNext-Regular-2ace005afb42cdf97f036e35c8b4579a.woff";